import { createReducer } from '@reduxjs/toolkit';

import { Loadable, FaftWorkTypesManager } from 'models';
import { makeThunkFromAPICall } from 'state';

export type FaftWorkTypesState = {
    faftWorkTypes: Loadable<FaftWorkTypesManager.FaftWorkTypes>;
    deleteFaftWorkTypesResponse: Loadable<FaftWorkTypesManager.ActionResponse>;
    faftWorkTypeDescriptions: Loadable<
        FaftWorkTypesManager.FaftWorkTypeDescriptions[]
    >;
};

const initialState: FaftWorkTypesState = {
    faftWorkTypes: {
        status: 'idle',
    },
    deleteFaftWorkTypesResponse: {
        status: 'idle',
    },
    faftWorkTypeDescriptions: {
        status: 'idle',
    },
};

export const [getFaftWorkTypes, setFaftWorkTypes] = makeThunkFromAPICall(
    FaftWorkTypesManager.getFaftWorkTypes,
    'faft/prioritisation/planid/workregister/faftid',
);

export const [updateFaftWorkTypes, setUpdateFaftWorkTypes] =
    makeThunkFromAPICall(
        FaftWorkTypesManager.updateFaftWorkTypes,
        'faft/prioritisation/planid/workregister/faftid/update',
    );

export const [deleteFaftWorkTypes, setDeleteFaftWorkTypes] =
    makeThunkFromAPICall(
        FaftWorkTypesManager.deleteFaftWorkTypes,
        'faft/prioritisation/workregister/faftid/delete',
    );

export const [getFaftWorkTypeDescriptions, setFaftWorkTypeDescriptions] =
    makeThunkFromAPICall(
        FaftWorkTypesManager.getFaftWorkTypeDescriptions,
        'faft/prioritisation/workregister/worktypedescriptions',
    );

export const faftWorkTypesReducer = createReducer(initialState, (builder) => {
    builder.addCase(setDeleteFaftWorkTypes, (state, action) => {
        return {
            ...state,
            deleteFaftWorkTypesResponse: {
                ...state.deleteFaftWorkTypesResponse,
                ...action.payload.loadable,
            },
        };
    });

    builder.addCase(setFaftWorkTypes, (state, action) => {
        return {
            ...state,
            faftWorkTypes: {
                ...state.faftWorkTypes,
                ...action.payload.loadable,
            },
        };
    });

    builder.addCase(setUpdateFaftWorkTypes, (state, action) => {
        return {
            ...state,
            faftWorkTypes: {
                ...state.faftWorkTypes,
                ...action.payload.loadable,
            },
        };
    });

    builder.addCase(setFaftWorkTypeDescriptions, (state, action) => {
        return {
            ...state,
            faftWorkTypeDescriptions: {
                ...state.faftWorkTypeDescriptions,
                ...action.payload.loadable,
            },
        };
    });
});

export const FaftWorkTypeActions = {
    getFaftWorkTypes,
    getFaftWorkTypeDescriptions,
    updateFaftWorkTypes,
    deleteFaftWorkTypes,
};

export default faftWorkTypesReducer;
